import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=7ef5207c&scoped=true"
import script from "./ResultView.vue?vue&type=script&lang=js"
export * from "./ResultView.vue?vue&type=script&lang=js"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=7ef5207c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef5207c",
  null
  
)

export default component.exports